import type { UserInvitation } from '~/entities/user/user/interfaces/user'
import { UserNetworkStatus } from '~/entities/user/user/interfaces/user'

export function validateUserSelection(status?: UserInvitation) {
  let isValid = true
  if (status) {
    if (status.user_in_network === 0 && status.connected_user_to_user === 'none' && status.user_to_connected_user === 'none')
      isValid = true

    else if (status.user_in_network === 1 || status.user_to_connected_user === 'decline' || (status.connected_user_to_user === 'new' && (status.user_to_connected_user === 'none' || status.user_to_connected_user === 'accept')) || status.user_in_network === 1)
      isValid = false
  }
  else if (usersSelected.value.length === 1) {
    isValid = false
  }
  return isValid
}

export function isUserInNetwork(status?: UserInvitation) {
  let inNetwork = UserNetworkStatus.InNetwork
  if (status && status.user_in_network === 0) {
    if (status.connected_user_to_user === 'new')
      inNetwork = UserNetworkStatus.InvitationSentPending

    else
      inNetwork = UserNetworkStatus.NotInNetwork
  }
  return inNetwork
}
